import { PortalSandboxPage } from "../../../components/gov/PortalSandboxPage";
import { QIWA_CONFIG } from "../../../components/gov/portalConfigs";

export function QiwaPortalPage() {
  return <PortalSandboxPage config={QIWA_CONFIG} />;
}

export default QiwaPortalPage;
